export default "__VITE_ASSET__DgHaFHH8__"